export default __webpack_public_path__ + "images/inmarket_logo.9537df5d562353f969eabaced429b95a.png";